/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_ApartmentInputs */

const en_val_apartment = /** @type {(inputs: Val_ApartmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apartment`)
};

const es_val_apartment = /** @type {(inputs: Val_ApartmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apartamento`)
};

const fr_val_apartment = /** @type {(inputs: Val_ApartmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appartement`)
};

const de_val_apartment = /** @type {(inputs: Val_ApartmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apartment`)
};

const ja_val_apartment = /** @type {(inputs: Val_ApartmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アパート・マンション`)
};

const zh_val_apartment = /** @type {(inputs: Val_ApartmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公寓`)
};

const ar_val_apartment = /** @type {(inputs: Val_ApartmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شقة`)
};

const id_val_apartment = /** @type {(inputs: Val_ApartmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apartemen`)
};

const it_val_apartment = /** @type {(inputs: Val_ApartmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appartamento`)
};

const ru_val_apartment = /** @type {(inputs: Val_ApartmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Апартаменты`)
};

const pt_val_apartment = /** @type {(inputs: Val_ApartmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apartamento`)
};

const ko_val_apartment = /** @type {(inputs: Val_ApartmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아파트`)
};

/**
* | output |
* | --- |
* | "Apartment" |
*
* @param {Val_ApartmentInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_apartment = /** @type {((inputs?: Val_ApartmentInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_ApartmentInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_apartment(inputs)
	if (locale === "es") return es_val_apartment(inputs)
	if (locale === "fr") return fr_val_apartment(inputs)
	if (locale === "de") return de_val_apartment(inputs)
	if (locale === "ja") return ja_val_apartment(inputs)
	if (locale === "zh") return zh_val_apartment(inputs)
	if (locale === "ar") return ar_val_apartment(inputs)
	if (locale === "id") return id_val_apartment(inputs)
	if (locale === "it") return it_val_apartment(inputs)
	if (locale === "ru") return ru_val_apartment(inputs)
	if (locale === "pt") return pt_val_apartment(inputs)
	return ko_val_apartment(inputs)
});